import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { cartAPI } from '../services/api';
import { useCustomerAuth } from './CustomerAuthContext';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState({ items: [], totalAmount: 0, itemCount: 0 });
    const [loading, setLoading] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { customer } = useCustomerAuth();

    const fetchCart = useCallback(async () => {
        try {
            const res = await cartAPI.get();
            setCart(res.data);
        } catch (e) { /* ignore */ }
    }, []);

    useEffect(() => { fetchCart(); }, [fetchCart, customer]);

    const addItem = async (productId, variantId = null, quantity = 1, selectedSize = null) => {
        setLoading(true);
        try {
            const res = await cartAPI.add({ productId, variantId, quantity, selectedSize });
            setCart(res.data);
            setSidebarOpen(true);
            return true;
        } catch (e) {
            alert(e.response?.data?.error || 'Sepete eklenirken hata oluştu');
            return false;
        } finally {
            setLoading(false);
        }
    };

    const updateItem = async (itemId, quantity) => {
        try {
            const res = await cartAPI.updateItem(itemId, { quantity });
            setCart(res.data);
        } catch (e) {
            alert(e.response?.data?.error || 'Hata oluştu');
        }
    };

    const removeItem = async (itemId) => {
        try {
            const res = await cartAPI.removeItem(itemId);
            setCart(res.data);
        } catch (e) { console.error(e); }
    };

    const clearCart = async () => {
        try {
            const res = await cartAPI.clear();
            setCart(res.data);
        } catch (e) { console.error(e); }
    };

    return (
        <CartContext.Provider value={{
            cart, loading, sidebarOpen, setSidebarOpen,
            addItem, updateItem, removeItem, clearCart, fetchCart
        }}>
            {children}
        </CartContext.Provider>
    );
};

const defaultCart = {
    cart: { items: [], totalAmount: 0, itemCount: 0 }, loading: false,
    sidebarOpen: false, setSidebarOpen: () => {},
    addItem: () => {}, updateItem: () => {}, removeItem: () => {},
    clearCart: () => {}, fetchCart: () => {}
};
export const useCart = () => useContext(CartContext) || defaultCart;
